var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 17",
    className: "si-glyph si-glyph-signal-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Signal-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,13.984 L8.5,13.984 C8.278,13.984 8.083,13.838 8.021,13.626 L6.647,8.984 L4.993,8.984 C4.762,8.984 4.561,8.826 4.507,8.601 L3.531,4.549 L2.483,8.609 C2.425,8.83 2.226,8.984 1.999,8.984 L0,8.984 L0,8.031 L1.61,8.031 L3.062,2.406 C3.12,2.185 3.318,2.031 3.546,2.031 L3.55,2.031 C3.779,2.033 3.979,2.191 4.032,2.414 L5.384,8.031 L7.019,8.031 C7.241,8.031 7.436,8.177 7.498,8.389 L8.503,11.735 L9.523,8.387 C9.586,8.175 9.781,8.031 10.002,8.031 L10.689,8.031 L12.036,5.295 C12.12,5.125 12.292,5.018 12.481,5.016 L12.485,5.016 C12.673,5.016 12.844,5.12 12.929,5.287 L14.339,8.031 L15.969,8.031 L15.969,8.984 L14.033,8.984 C13.845,8.984 13.674,8.88 13.589,8.713 L12.494,6.582 L11.447,8.705 C11.364,8.876 11.19,8.984 11,8.984 L10.374,8.984 L8.978,13.628 C8.915,13.84 8.721,13.984 8.5,13.984 L8.5,13.984 Z",
    fill: "#434343",
    className: "si-glyph-fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.989c8eafa5d654295cd11f7ac92f8560.svg";
export { ForwardRef as ReactComponent };